var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lazy-image"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imageURL),expression:"imageURL"}],style:({
      maxWidth: _vm.imageMaxWidth,
      maxHeight: _vm.imageMaxHeight,
    }),attrs:{"alt":_vm.imageTitle,"width":_vm.imageWidth,"height":_vm.imageHeight}}),_c('div',{staticClass:"loading",style:({
      top: _vm.loadingTop,
      left: _vm.loadingLeft,
    })},[_c('div'),_c('div')])])}
var staticRenderFns = []

export { render, staticRenderFns }